import {TASK_STATUS_ORDER, type Task, type TaskStatus} from '../model/types';

/** Контекст пользователя для локального mock; real-права возвращает сервер. */
export interface TaskActor {
  userSid?: string;
}

/** Финальные состояния может менять только создатель. */
export const isFinalTaskStatus = (status: TaskStatus): boolean =>
  status === 'done' || status === 'partial';

/** Роль пользователя не заменяет авторство задачи. */
export const canManageTask = (task: Task, actor: TaskActor): boolean =>
  task.permissions?.canEdit ??
  Boolean(actor.userSid && task.creatorUserSid === actor.userSid);

/** Разрешённые переходы; исполнитель не входит в финальные статусы и не выходит из них. */
export const canSetTaskStatus = (
  task: Task,
  status: TaskStatus,
  actor: TaskActor,
): boolean => {
  if (task.permissions) return task.permissions.allowedStates.includes(status);
  if (canManageTask(task, actor)) return TASK_STATUS_ORDER.includes(status);
  return Boolean(
    actor.userSid &&
    task.managerId === actor.userSid &&
    !isFinalTaskStatus(task.status) &&
    !isFinalTaskStatus(status),
  );
};
